import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';

// Single axios instance for all API calls
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://api.groomservices.tech/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add Bearer token and handle FormData for multipart uploads
api.interceptors.request.use((config) => {
  const token = secureLocalStorage.getItem('token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Let axios set Content-Type for FormData (multipart/form-data with boundary)
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  return config;
});

let sessionExpiredRedirecting = false;

function clearAllAppStorage() {
  try {
    sessionStorage.clear();
  } catch {
    /* ignore */
  }
  try {
    secureLocalStorage.clear();
  } catch {
    try {
      secureLocalStorage.removeItem('token');
    } catch {
      /* ignore */
    }
  }
}

function isAuthCredentialRequest(config) {
  const url = config?.url || '';
  return url.includes('/login') || url.includes('/verify-otp');
}

function shouldSessionExpireLogout(error) {
  if (!error.response) return false;
  const status = error.response.status;
  const data = error.response.data;
  let message = '';
  if (typeof data === 'string') message = data;
  else if (data != null) {
    if (data.message) message = String(data.message);
    else if (data.error) message = String(data.error);
  }
  const lower = message.toLowerCase();
  const tokenMessage =
    lower.includes('invalid token') ||
    lower.includes('token expired') ||
    lower.includes('token invalid');
  return status === 401 || tokenMessage;
}

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const config = error.config;
    if (
      config &&
      !isAuthCredentialRequest(config) &&
      shouldSessionExpireLogout(error) &&
      !sessionExpiredRedirecting
    ) {
      sessionExpiredRedirecting = true;
      clearAllAppStorage();
      window.location.replace('/login');
    }
    return Promise.reject(error);
  }
);

// Extract error message from axios errors
export const getErrorMessage = (error) => {
  if (error.response?.status === 413) {
    return 'Upload is too large for the server. Try a smaller image, or increase the limit in your reverse proxy (e.g. nginx client_max_body_size).';
  }
  if (error.response?.data != null) {
    const data = error.response.data;
    if (typeof data === 'string') return data;
    if (data?.message) return data.message;
    if (data?.error) return data.error;
  }
  return error.message || 'Request failed';
};

export default api;
